import { IconPhoto } from '@tabler/icons-react'

import { ImageDisplayBlock as RenderImageDisplayBlock } from '../../templateRenderer/DisplayBlocks/ImageDisplayBlock'
import { ImageDisplayBlock } from '../../types/blueprint'

import {
  BaseBlockConfig,
  Field,
  InputField,
  TypeOption,
  UploaderField,
} from './_BaseBlockConfig'

class Config extends BaseBlockConfig<ImageDisplayBlock> {
  public override kind = 'display' as const
  public override type = 'image' as const

  public override blockTypeConfig: TypeOption = {
    kind: this.kind,
    value: this.type,
    label: 'Image / document',
    icon: IconPhoto,
    helpText: 'Embed a picture or document',
    hideDescription: true,
  }

  public override blockFieldsConfig: Field[] = [
    {
      name: 'url',
      label: 'Image / document',
      field: UploaderField,
      required: true,
    },
    {
      name: 'altText',
      label: 'Alt text',
      helpText: "The text that will be displayed if your image doesn't load",
      field: InputField,
    },
    {
      name: 'caption',
      label: 'Caption',
      helpText: 'The text that will be displayed along side your image',
      field: InputField,
    },
  ]

  public override mapFormValueToBlock(
    block: ImageDisplayBlock
  ): ImageDisplayBlock {
    return block
  }

  public override renderBlock(block: ImageDisplayBlock): React.ReactNode {
    return <RenderImageDisplayBlock block={block} />
  }
}

export const ImageDisplayBlockConfig = new Config()
